import { render } from "./NoticeBox.vue?vue&type=template&id=63a7a2a0&scoped=true"
import script from "./NoticeBox.vue?vue&type=script&lang=js"
export * from "./NoticeBox.vue?vue&type=script&lang=js"

import "./NoticeBox.vue?vue&type=style&index=0&id=63a7a2a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a7a2a0"]])

export default __exports__